<div class="spinner-overlay" *ngIf="isLoading">
  <nz-spin nzSpinning="true" nzSize="large">
    <div class="spinner-content">{{ message }}</div>
  </nz-spin>
</div>
